import Vue from 'vue'
import StoreSearch from '../vue/StoreSearch/StoreSearch'
import store from '../vue/StoreSearch/store'

const props = {
  $storeSearchEl: document.getElementById('store-search-app')
}

const fn = {
  init: () => {
    window._storeApiEndpoint = props.$storeSearchEl.dataset.apiEndpoint

    new Vue({
      el: props.$storeSearchEl,
      store,
      render: h => h(StoreSearch)
    })
  }
}

export default {
  can: () => props.$storeSearchEl,
  run: fn.init
}
